import { render, staticRenderFns } from "./SafariWarning.vue?vue&type=template&id=6abaecb0&scoped=true"
import script from "./SafariWarning.vue?vue&type=script&lang=js"
export * from "./SafariWarning.vue?vue&type=script&lang=js"
import style0 from "./SafariWarning.vue?vue&type=style&index=0&id=6abaecb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abaecb0",
  null
  
)

export default component.exports